export enum AddButtonType {
  ENABLED,
  RENTAL_CONTRACT,
}
